import { startCase } from 'lodash';

import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { DocumentPdfContentTypeDetection, PdfContentType } from 'dashboard/models/check';

const PDF_CONTENT_TYPE_TO_ADDITIONAL_INFORMATION: Record<PdfContentType, string> = {
  regular:
    'The PDF only contains standard content with no indicators of suspicious activity based solely on the content type.',
  image_based:
    'The PDF only contains image-based content, likely from a scanned document or an image exported as a PDF.',
  mixed:
    'The PDF contains a mix of standard content pages and image-based pages. Mixed content types can indicate the use of image-based editors, such as GIMP or Photoshop, to create or modify the PDF.',
};

export const computeDocumentPdfContentTypeDetectionMetadata = (
  check: DocumentPdfContentTypeDetection,
): CheckMetadata => {
  if (check.reasons && check.reasons.length > 0 && check.metadata) {
    const detectedContentType = check.metadata['detected-content-type'];
    return {
      metadata: createSimpleCheckMetadataArray([
        {
          label: 'Filename',
          value: check.metadata['filename'] ? check.metadata['filename'].toUpperCase() : '-',
        },
        {
          label: 'Detected Content Type',
          value: startCase(detectedContentType) || '-',
        },
        {
          label: 'Additional Information',
          value: PDF_CONTENT_TYPE_TO_ADDITIONAL_INFORMATION[detectedContentType] || '-',
        },
      ]),
      hideIfVerificationPassed: true,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: true,
  };
};
